<template>
  <div class="payflex-view">
    <v-container fluid class="payflex-container">
      <v-row align="center" justify="space-between" class="ma-0 mb-5">
        <v-col cols="12" sm="8" class="pa-0">
          <h1 class="payflex-title">PayFlex</h1>
          <p class="payflex-subtitle">
            Panel de administración PayFlex
          </p>
        </v-col>

        <v-col cols="12" sm="4" class="pa-0 text-sm-right">
          <v-btn
            color="#4169f5"
            class="white--text payflex-button"
            :disabled="!payflexUrl"
            :href="payflexUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            Abrir en nueva pestaña
          </v-btn>
        </v-col>
      </v-row>

      <v-card class="payflex-card" elevation="0">
        <div class="payflex-frame-wrapper">
          <v-overlay absolute :value="isLoadingIframe" color="#ffffff" opacity="0.9">
            <v-progress-circular indeterminate color="#4169f5"></v-progress-circular>
          </v-overlay>

          <iframe
            v-if="payflexUrl"
            class="payflex-frame"
            :src="payflexUrl"
            title="PayFlex admin panel"
            referrerpolicy="no-referrer"
            @load="isLoadingIframe = false"
          ></iframe>

          <div v-else class="payflex-empty">
            {{ payflexError || "No se ha configurado la URL de PayFlex." }}
          </div>
        </div>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "PayflexView",
  data() {
    return {
      isLoadingIframe: true,
      payflexUrl: "",
      payflexError: "",
    };
  },
  mounted() {
    this.getPayflexUrl();
  },
  methods: {
    async getPayflexUrl() {
      this.isLoadingIframe = true;
      this.payflexError = "";

      try {
        const response = await DB.get(`${URI}/api/v1/en/dashboard/payflex`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        });

        this.payflexUrl = response.data.url || response.data.data?.url || response.data.data?.ssoUrl || "";

        if (!this.payflexUrl) {
          this.payflexError = "No se recibió la URL de PayFlex.";
          this.isLoadingIframe = false;
        }
      } catch (error) {
        this.payflexUrl = "";
        this.payflexError = error.response?.data?.message || "No fue posible cargar PayFlex.";
        this.isLoadingIframe = false;
        this.mixError(this.payflexError, error.response?.status || 400);
      }
    },
  },
};
</script>

<style scoped>
.payflex-view {
  min-height: 100%;
  background: #f4f7fb;
  padding: 24px 0;
}

.payflex-container {
  padding-left: 44px;
  padding-right: 44px;
}

.payflex-title {
  margin: 0;
  color: #18233a;
  font-family: "montserrat-bold";
  font-size: 32px;
  line-height: 40px;
}

.payflex-subtitle {
  margin: 6px 0 0;
  color: #6f7b91;
  font-family: "montserrat-regular";
  font-size: 14px;
}

.payflex-button {
  border-radius: 24px;
  font-family: "montserrat-semibold";
  text-transform: none;
}

.payflex-card {
  overflow: hidden;
  border-radius: 24px;
  background: #ffffff;
  border: 1px solid #e7ecf5;
}

.payflex-card-header {
  min-height: 72px;
  padding: 18px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e7ecf5;
}

.payflex-card-title {
  color: #18233a;
  font-family: "montserrat-bold";
  font-size: 22px;
}

.payflex-status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border-radius: 24px;
  color: #6f7b91;
  font-family: "montserrat-semibold";
  background: #ffffff;
  border: 1px solid #eef2f7;
  box-shadow: 0 8px 24px rgba(24, 35, 58, 0.08);
}

.payflex-status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #22c778;
  box-shadow: 0 0 0 5px rgba(34, 199, 120, 0.12);
}

.payflex-frame-wrapper {
  position: relative;
  height: calc(100vh - 220px);
  min-height: 620px;
  background: #ffffff;
}

.payflex-frame {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
}

.payflex-empty {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6f7b91;
  font-family: "montserrat-medium";
}

@media (max-width: 600px) {
  .payflex-container {
    padding-left: 16px;
    padding-right: 16px;
  }

  .payflex-title {
    font-size: 28px;
  }

  .payflex-button {
    margin-top: 16px;
    width: 100%;
  }

  .payflex-card {
    border-radius: 16px;
  }

  .payflex-card-header {
    align-items: flex-start;
    gap: 12px;
    flex-direction: column;
  }

  .payflex-frame-wrapper {
    height: calc(100vh - 260px);
    min-height: 520px;
  }
}
</style>
